import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chips", "chip", "input"]

  add(event) {
    event.preventDefault()
    this.addTerms(this.inputTarget.value)
    this.inputTarget.value = ""
    this.inputTarget.focus()
  }

  handleKeydown(event) {
    if (event.key !== "Enter") return

    event.preventDefault()
    this.addTerms(this.inputTarget.value)
    this.inputTarget.value = ""
  }

  handlePaste(event) {
    const pastedText = event.clipboardData?.getData("text")
    if (!pastedText?.includes(",")) return

    event.preventDefault()
    this.addTerms(pastedText)
    this.inputTarget.value = ""
  }

  remove(event) {
    event.preventDefault()
    event.currentTarget.closest(".search-chip")?.remove()
  }

  focusInput() {
    this.inputTarget.focus()
  }

  addTerms(value) {
    value.split(",").map((term) => term.trim()).filter(Boolean).forEach((term) => {
      if (this.hasTerm(term)) return

      this.inputTarget.insertAdjacentElement("beforebegin", this.buildChip(term))
    })
  }

  hasTerm(term) {
    return this.chipTargets.some((chip) => chip.dataset.value.toLowerCase() === term.toLowerCase())
  }

  buildChip(term) {
    const chip = document.createElement("span")
    chip.className = "search-chip"
    chip.dataset.searchChipsTarget = "chip"
    chip.dataset.value = term

    const label = document.createElement("span")
    label.textContent = term

    const removeButton = document.createElement("button")
    removeButton.type = "button"
    removeButton.className = "search-chip-remove"
    removeButton.setAttribute("aria-label", `Remove search term ${term}`)
    removeButton.dataset.action = "search-chips#remove"
    removeButton.innerHTML = '<i class="bi bi-x-lg" aria-hidden="true"></i>'

    const hiddenInput = document.createElement("input")
    hiddenInput.type = "hidden"
    hiddenInput.name = "search_terms[]"
    hiddenInput.value = term

    chip.append(label, removeButton, hiddenInput)
    return chip
  }
}
